import React from 'react';
import { useStyles } from '@wix/tpa-settings/react';
import {
  Text,
  TextButton,
  TextButtonPriority,
  TextTypography,
} from '@wix/wix-ui-tpa/cssVars';
import { Clock, Location } from '@wix/wix-ui-icons-common/on-stage';

import { useGetLayoutSize } from '../../../../components-shared/LayoutSizeProvider';
import { dispatchInfoStylesParams } from '../../Settings/Tabs/Design/DispatchInfo/stylesParams';

import { classes, st } from './DispatchInfo.st.css';
import { dispatchInfoDataHooks } from './constants';
import { useHooks } from './useHooks';

export type DispatchInfoProps = {
  className?: string;
};

const DispatchInfo: React.FC<DispatchInfoProps> = ({ className }) => {
  const {
    timeString,
    timeChangeButtonLabel,
    addressLabel,
    addressChangeButtonLabel,
    showTimeRow,
    showAddressRow,
    showTimeChangeButton,
    showAddressChangeButton,
    onChangeTime,
    onChangeAddress,
  } = useHooks();

  const { layoutSize } = useGetLayoutSize();
  const styles = useStyles();
  const showIcon = styles.get(dispatchInfoStylesParams.dispatchShowIcon);
  const iconSize = styles.get(dispatchInfoStylesParams.dispatchIconSize);

  if (!showTimeRow && !showAddressRow) {
    return null;
  }

  return (
    <div
      className={st(classes.root, { [layoutSize]: true }, className)}
      data-hook={dispatchInfoDataHooks.root()}
    >
      {showTimeRow && (
        <div
          className={classes.row}
          data-hook={dispatchInfoDataHooks.timeRow()}
        >
          {showIcon && (
            <Clock
              className={classes.icon}
              width={iconSize}
              height={iconSize}
              aria-hidden
            />
          )}
          <Text
            id="dispatch-time-label"
            className={classes.label}
            typography={TextTypography.runningText}
            data-hook={dispatchInfoDataHooks.timeLabel()}
          >
            {timeString}
          </Text>
          {showTimeChangeButton && (
            <TextButton
              id="dispatch-time-change-btn"
              className={classes.textButton}
              priority={TextButtonPriority.secondary}
              onClick={onChangeTime}
              data-hook={dispatchInfoDataHooks.timeChangeButton()}
              aria-labelledby="dispatch-time-change-btn dispatch-time-label"
            >
              {timeChangeButtonLabel}
            </TextButton>
          )}
        </div>
      )}
      {showAddressRow && (
        <div
          className={classes.row}
          data-hook={dispatchInfoDataHooks.addressRow()}
        >
          {showIcon && (
            <Location
              className={classes.icon}
              width={iconSize}
              height={iconSize}
              aria-hidden
            />
          )}
          {addressLabel !== null && (
            <Text
              id="dispatch-address-label"
              className={classes.label}
              typography={TextTypography.runningText}
              data-hook={dispatchInfoDataHooks.addressLabel()}
            >
              {addressLabel}
            </Text>
          )}
          {showAddressChangeButton && (
            <TextButton
              id="dispatch-address-change-btn"
              className={classes.textButton}
              priority={TextButtonPriority.secondary}
              onClick={onChangeAddress}
              data-hook={dispatchInfoDataHooks.addressChangeButton()}
              aria-labelledby="dispatch-address-change-btn dispatch-address-label"
            >
              {addressChangeButtonLabel}
            </TextButton>
          )}
        </div>
      )}
    </div>
  );
};

export default DispatchInfo;
